import Addresses from '@/views/jobs/Addresses'
import Index from '@/views/jobs/Index.vue'
import Update from '@/views/jobs/Update'

export default [
    {
        path: '/jobs',
        name: 'jobs',
        component: Index,
        meta: { title: 'Jobverwaltung' }
    },
    {
        path: '/jobs/index',
        redirect: '/jobs'
    },
    {
        path: '/jobs/:jobId/offers/:offerId',
        name: 'jobs/update',
        component: Update,
        meta: { title: (route, store) => {
            const job = store.getters['jobs/byId'](Number(route.params.jobId))
            const product = store.getters['products/byId'](job?.product)
            return product?.zmuekId ? `Angebote – Produkt ID: ${product.zmuekId}` : 'Angebote'
        }}
    },
    {
        path: '/jobs/:jobId/addresses',
        name: 'jobs/addresses',
        component: Addresses,
        meta: { title: (route, store) => {
            const job = store.getters['jobs/byId'](Number(route.params.jobId))
            const product = store.getters['products/byId'](job?.product)
            return product?.zmuekId ? `Adressen – Produkt ID: ${product.zmuekId}` : 'Adressen'
        }}
    },


]
